module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306361.36acb123.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306361.pdf
// module id = 820
// module chunks = 0